import { useMemo } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

// Always a <span>, even in displayMode: this renders inside whatever inline
// text run mui-markdown is already building (typically inside a <p>), and
// KaTeX's own `.katex-display` class already renders block-level and
// centered -- an actual <div> here would end up nested inside that <p>,
// which is invalid HTML and would make React (and the browser) split or
// warn about the paragraph.
export function KatexSpan({ expression, displayMode }: { expression: string; displayMode: boolean }) {
    const html = useMemo(() => katex.renderToString(expression, {
        throwOnError: false,
        displayMode,
        errorColor: '#cc0000',
    }), [expression, displayMode]);
    return <span dangerouslySetInnerHTML={{ __html: html }} />;
}
